import React, {useEffect, useLayoutEffect, useState, useMemo, useReducer, useContext} from 'react'
import {useParams, useNavigate} from 'react-router-dom'
import OrderService from '../services/OrderService';
import {MaterialReactTable} from 'material-react-table';
import {Box, Button, ListItemIcon, MenuItem, Typography} from '@mui/material';
import {Context} from '../index';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import EntityList from "../components/EntityList";
import {toJS} from "mobx";
import MyButton from "../UI/MyButton/MyButton";
import ConsignmentConverter from '../utils/ConsignmentConverter';
import { READY_BUTTONS, STATES } from '../config';
import { useTranslation } from 'react-i18next';

/**
 * выводить:
 * имя, дату, способ доставки, позиции
 * name, moment/created?, attributes.find(attribute => attribute.name == 'Способ доставки NEW').value, positions
 */

export default function OrderById() {
    const {store} = useContext(Context);
    const { t } = useTranslation();
    const pagination = {
        pageSize: 100
    }
    // Use config for buttons and states (supports multi-instance deployment)
    const readyButtons = READY_BUTTONS;
    const STATES_MAP = STATES;
    const [order, setOrder] = useState([]);
    const [rowSelection, setRowSelection] = useState({});
    let [barcodeParts, setBarcodeParts] = useState('');
    const [barcode, setBarcode] = useState({});
    const [, forceUpdate] = useReducer(x => x + 1, 0);
    const params = useParams();
    const [showPopup, setShowPopup] = useState(false);
    const [isWaitingButtonClicked, setIsWaitingButtonClicked] = useState(false);
    const [isCorrectButtonClicked, setIsCorrectButtonClicked] = useState(false);
    const [orderCorrectReason, setOrderCorrectReason] = useState("");
    const [orderWaitingReason, setOrderWaitingReason] = useState("");
    const [scannedConsignments, setScannedConsignments] = useState({});
    const navigate = useNavigate();
    const columns = useMemo(
        () => [
            {
                accessorKey: 'image',
                header: t('label.image'),
                size: 200,
                Cell: ({cell}) => (
                    <img
                        alt={t('msg.noImage')}
                        src={cell.getValue()}/>
                )
            },
            {
                accessorKey: 'article',
                header: t('label.article'),
                size: 200
            },
            {
                accessorKey: 'name',
                header: t('label.name'),
                size: 200,
                Cell: ({ row }) => {
                    const item = row.original;
                    const hasConsignment = item.type === 'consignment' && item.consignmentLabel;

                    return (
                        <div>
                            <div>{item.name}</div>
                            {hasConsignment && (
                                <div style={{
                                    display: 'inline-block',
                                    marginTop: '4px',
                                    padding: '2px 8px',
                                    fontSize: '11px',
                                    fontWeight: 'bold',
                                    color: '#1565c0',
                                    backgroundColor: '#e3f2fd',
                                    border: '1px solid #90caf9',
                                    borderRadius: '4px'
                                }}>
                                    {t('orders.series')} {item.consignmentLabel}
                                </div>
                            )}
                        </div>
                    );
                }
            },
            {
                accessorKey: 'quantity',
                header: t('label.quantity'),
                size: 200,
                Cell: ({cell}) => (
                    <span style={{fontSize: '20px'}}>
                        {cell.getValue()}
                    </span>
                )
            }
        ],
        [t],
    );

    useEffect(() => {
        getOrderById(params.id);
        uploadSelectedRowsFromServer();

    }, [params.id])

    async function uploadSelectedRowsFromServer() {
        try {
            const response = await store.checkEntitiesInWork();

            const orderInStore = toJS(store.entitiesInWork);
            const rowsToUpdate = orderInStore.find(item => item.id === params.id).selectedPositions;

            console.log('order in store', rowsToUpdate)

            setRowSelection({...rowsToUpdate});

        } catch (e) {
            console.log(e);
        }
    }


    useEffect(() => {
        console.log(rowSelection);
        const orderInStoree = updateSelectedPositions();

    }, [rowSelection])

    async function updateSelectedPositions() {
        const updateRows = Object.assign({}, rowSelection);
        console.log('updateRows', updateRows);
        let serverResToUpdateSelectedPositions;
        if (Object.keys(updateRows).length > 0) {
            await OrderService.updateSelectedPositions(params.id, {updateRows});
        }

        return serverResToUpdateSelectedPositions;
    }

    useEffect(() => {
        function handleKeyDown(e) {
            if (e.key === 'Enter') {
                setBarcode({value: parseScannedInput(barcodeParts)});
                setBarcodeParts('');
                return;
            }

            let newBarcode = barcodeParts.concat(e.key);
            setBarcodeParts(newBarcode);
        }

        document.addEventListener('keydown', handleKeyDown);

        return function cleanup() {
            document.removeEventListener('keydown', handleKeyDown);
        }
    }, [barcodeParts]);

    useEffect(() => {
        if (order.length !== 0) {
            console.log('order', order);

            // Сначала ищем среди обычных штрихкодов
            let scannedProduct = order.positions.find(position => position.barcode === barcode.value);

            // Если не найдено - ищем среди штрихкодов серий (consignmentBarcode)
            if (!scannedProduct) {
                scannedProduct = order.positions.find(position =>
                    position.consignmentBarcode === barcode.value &&
                    position.type === 'consignment'
                );
            }

            console.log(barcode.value);
            console.log(scannedProduct);

            if (!scannedProduct) {
                setBarcodeParts('');
                setShowPopup(true);
                return;
            }

            // Проверка на повторное сканирование той же серии
            if (scannedProduct.type === 'consignment') {
                if (scannedConsignments[scannedProduct.id]) {
                    setBarcodeParts('');
                    setShowPopup(true);
                    return;
                }
                // Отмечаем серию как отсканированную
                setScannedConsignments(prev => ({
                    ...prev,
                    [scannedProduct.id]: true
                }));
            }

            const selectedRow = Object.assign(rowSelection, {[scannedProduct.id]: true});
            setRowSelection((selectedRow) => (selectedRow));
            console.log('selected row', selectedRow);
        }
        forceUpdate();
    }, [barcode])

    async function getOrderById(id) {
        let orderIsTaken = false;
        while (!orderIsTaken) {
            try {
                const response = await OrderService.getOrderById(id);
                console.log(response);

                setOrder(response.data);
                orderIsTaken = true;

            } catch (e) {
                console.log(e);

                if (e.response?.status === 410) {
                    const errorData = e.response.data;
                    alert(`${errorData.message || t('orders.orderAlreadyCompleted')}`);

                    navigate('/start');
                    return;
                }
            }
        }
    }

    function parseScannedInput(input) {
        const matches = input.match(/Alt(\d+)/g);
        if (!matches) return input;

        return matches.map((code) => {
            const num = code.replace("Alt", "");
            return String.fromCharCode(parseInt(num));
        }).join('');
    }

    const handleSendToCorrect = async () => {
        try {
            const result = await OrderService.changeOrderStatus(params.id, 'correction', orderCorrectReason);
            console.log(result);
            console.log(store.user.id);
            const serverRes = await OrderService.moveOrderToWaitingList(params.id, 'correct', orderCorrectReason);
            alert(t('orders.orderSentForCorrection', { name: order.name }))
            navigate('/start')

        } catch (error) {
            alert(t('msg.errorSomethingWentWrong', { message: error.message }))
        }
    };

    const handleToWaitingList = async () => {
        const serverRes = await OrderService.moveOrderToWaitingList(params.id, 'waiting', orderWaitingReason);
        alert(t('orders.orderSentToWaiting', { name: order.name }))
        navigate('/start');
    };


    return (
        <div>
            {order?.positions
                ?
                <MaterialReactTable columns={columns} data={order.positions}
                                    enableRowSelection
                                    enableSelectAll={false}
                                    onRowSelectionChange={setRowSelection}
                                    initialState={{pagination}}
                                    getRowId={(originalRow)=> originalRow.id}
                                    state={{rowSelection}}
                                    renderTopToolbarCustomActions={({table}) => {
                                        const handleCollectOrder = async () => {
                                            try {
                                                const result = await OrderService.changeOrderStatus(params.id, STATES_MAP.get(store.user.position));
                                                console.log(result);
                                                const removeOrderFromWork = await OrderService.removeOrderFromWork(params.id, store.user.position);
                                                console.log(removeOrderFromWork)
                                                alert(t('orders.orderStatusChanged', { name: order.name, status: STATES_MAP.get(store.user.position) }))
                                                navigate('/start')
                                            } catch (error) {
                                                alert(t('msg.errorSomethingWentWrong', { message: error.message }))
                                            }
                                        };

                                        return (
                                            <div>
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    marginTop: 9,
                                                    marginLeft: 35
                                                }}>{t('label.comment')} <b>{order.description}</b></div>
                                                <div style={{display: 'flex', gap: '0.5rem'}}>
                                                    <Button
                                                        color="success"
                                                        disabled={!table.getIsAllRowsSelected()}
                                                        onClick={handleCollectOrder}
                                                        variant="contained"
                                                    >
                                                        {readyButtons[store.user.position]}
                                                    </Button>
                                                    <Button
                                                        color="error"
                                                        onClick={() => setIsCorrectButtonClicked(true)}
                                                        variant="contained"
                                                    >
                                                        {t('orders.correction')}
                                                    </Button>
                                                    <Button
                                                        color="primary"
                                                        onClick={() => setIsWaitingButtonClicked(true)}
                                                        variant="contained"
                                                    >
                                                        {t('orders.toWaiting')}
                                                    </Button>
                                                </div>
                                                <div style={{display: "flex"}}>
                                                    <div style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        marginTop: 9,
                                                        marginLeft: 35
                                                    }}>{t('orders.order')} <b>{order.name}</b></div>
                                                    <div style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        marginTop: 9,
                                                        marginLeft: 35
                                                    }}>{t('orders.delivery')} <b>{order.delivery}</b></div>
                                                </div>
                                            </div>
                                        );
                                    }}
                />
                :
                ""}
            <Popup open={showPopup} onClose={() => setShowPopup(false)}><h4> {t('orders.invalidBarcode')} </h4></Popup>
            <Popup open={isCorrectButtonClicked} onClose={() => setIsCorrectButtonClicked(false)}>
                <h2> {t('orders.specifyCorrectionReason')} </h2>
                <input
                    onChange={(e) => {
                        setOrderCorrectReason(e.target.value)
                    }}
                    name={"correct_reason"}
                    value={orderCorrectReason}
                    type="text"
                    placeholder={t('orders.correctionReasonPlaceholder')}
                />
                <MyButton onClick={() => handleSendToCorrect()}> {t('btn.send')} </MyButton>
            </Popup>
            <Popup open={isWaitingButtonClicked} onClose={() => setIsWaitingButtonClicked(false)}>
                <h2> {t('orders.specifyWaitingReason')} </h2>
                <input
                    onChange={(e) => {
                        setOrderWaitingReason(e.target.value)
                    }}
                    name={"waiting_reason"}
                    value={orderWaitingReason}
                    type="text"
                    placeholder={t('orders.waitingReasonPlaceholder')}
                />
                <MyButton onClick={() => handleToWaitingList()}> {t('btn.send')} </MyButton>
            </Popup>
            {/* Loading component */}
        </div>
    )
}
